import { supabase } from '../lib/supabase';

export const checkStorageSetup = async () => {
  try {
    const { data: buckets, error } = await supabase.storage.listBuckets();
    
    if (error || !buckets?.find(b => b.name === 'avatars')) {
      console.warn('⚠️ Avatar storage not configured!');
      console.log('\n📋 To set up avatar storage:');
      console.log('1. Run: window.createAvatarBucket()');
      console.log('2. Follow the instructions in SUPABASE_STORAGE_SETUP.md');
      console.log('3. Apply policies from AVATAR_STORAGE_POLICIES.sql');
      console.log('4. Test with: window.testAvatarStorage()');
      console.log('\n💡 Quick test: window.testAvatarStorage()');
      return false;
    }
    
    console.log('✅ Avatar storage bucket found');
    return true;
  } catch (error) {
    console.error('Error checking storage:', error);
    return false;
  }
};

// Auto-check on load
if (typeof window !== 'undefined') {
  setTimeout(() => {
    checkStorageSetup();
  }, 2000);
  
  window.checkStorageSetup = checkStorageSetup;
}